module.exports = __webpack_public_path__ + "static/media/Reservation_Layout_US.2063b55a.docx";